import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CanComponentDeactivate } from '@fry/components/common/form';
import { FormData } from '@fry/lib/forms';
import { NotifyService } from '@fry/lib/utils';
import { UserField, UserFieldsStore } from '@fry/lib/user-fields';
import { UserFieldForm } from '@fry/components/user-fields/user-field.form';

@Component({
    selector: 'app-user-field-add',
    templateUrl: './user-field-add.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFieldAddComponent implements OnInit, OnDestroy, CanComponentDeactivate {

  public userField: UserField;
  public formData$: Observable<FormData>;

  private destroyed$ = new Subject<void>();

  constructor(
    private userfields: UserFieldsStore,
    private form: UserFieldForm,
    private notify: NotifyService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.userField = this.userfields.blank();
    this.formData$ = this.form.init(this.userField);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    this.form.submit(this.userField)
                .pipe(takeUntil(this.destroyed$))
                .subscribe(
      data => {
        this.userField = data;
        this.notify.success($localize `User successfully field saved`);
        this.router.navigate(['user-fields']);
      },
      error => this.notify.error(error)
    );
  }

  canSafelyDeactivate() {
    return this.form.pristine;
  }
}
